import React, { useEffect, useState } from 'react'
import * as ReportCategory from './ReportCategory'
import {
  Box,
  Button, Chip, Collapse,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid, RadioGroup,
  Typography
} from '@mui/material'
import { FormProvider } from 'react-hook-form'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

const CommunityForm = ({ post, comment, methods, onNext, onClose }) => {
  const { register, formState: { errors } } = methods
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [expanded, setExpanded] = useState(false)
  const category = methods.watch('category') ? methods.watch('category') : null

  const chipOnClickHandler = (event) => {
    setSelectedCategory(event.target.innerText)
    methods.setValue('category', event.target.innerText)
    setExpanded(true)
  }

  useEffect(() => {
    console.log(category)
  }, [category])

  const ReportCategoryChipGroup = (
    <Grid item xs={12}>
       <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignContent: 'center',
          justifyContent: 'flex-start',
          m: -1
        }}
       >
        <RadioGroup
          row
          aria-labelledby="row-radio-chips-group"
          name="radio-chips-groupup"
          sx={{ flexWrap: 'wrap', gap: 1 }}
        >
          {
            ReportCategory.getReportCategoryList(post?.communityId || comment?.communityId).map((category) => {
              const checked = selectedCategory === category.name
              return (
              <Chip
                key={category.name}
                label={category.name}
                variant="plain"
                color={checked ? 'primary' : 'default'}
                {...register('category', { required: { value: true, message: 'Invalid Format' } })}
                onClick={chipOnClickHandler}
              />
              )
            })}
        </RadioGroup>
       </Box>
    </Grid>
  )

  const ReportCategoryAnnotation = () => {
    let annotation = ''
    ReportCategory.getReportCategoryList(post?.communityId || comment?.communityId).forEach((category) => {
      if (category.name === selectedCategory) {
        annotation = category.annotation
      }
    })

    return (
      <>
        {selectedCategory
          ? (
            <Grid item xs={12} sx={{ mt: '1rem' }}>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Typography variant="h6">
                  {selectedCategory}
                </Typography>
                <Typography variant="subtitle1" style={{ lineHeight: '20px', marginTop: '0.5rem' }}>
                  {annotation}
                </Typography>
              </Collapse>
            </Grid>
            )
          : undefined}
      </>
    )
  }

  return (
    <FormProvider {...methods}>
      <form>
        <DialogTitle>Submit a report</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText>
            Thanks for looking out for yourself and your fellow redditors by reporting things that break the rules. Let us know what&apos;s happening, and we&apos;ll look into it.
          </DialogContentText>
          <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
            {ReportCategoryChipGroup}
            <ReportCategoryAnnotation />
          </Grid>
          <DialogActions>
            {selectedCategory
              ? (
                <Button onClick={onNext}>Next</Button>
                )
              : (
                <Button onClick={onNext} disabled>Next</Button>
                )
            }
          </DialogActions>
        </DialogContent>
      </form>
    </FormProvider>
  )
}

export default CommunityForm
